import { useState, useEffect } from "react";

const NAV_ITEMS = [
  { label: "Watch", hasDropdown: true },
  { label: "TV", hasDropdown: true },
  { label: "Broadband", hasDropdown: true },
  { label: "Mobile", hasDropdown: true },
  { label: "Protect", hasDropdown: false },
  { label: "Business", hasDropdown: false },
  { label: "Extra", hasDropdown: false },
];

const STREAMING_PLATFORMS = [
  { name: "Disney+", show: "Grey's Anatomy", status: "Now streaming", color: "#0f2b6b" },
  { name: "NETFLIX", show: "Bridgerton", status: "Watch now", color: "#e50914" },
  { name: "sky", show: "Under Salt March", status: "Available now", color: "#0072c6" },
  { name: "HBO Max", show: "The Pits", status: "Available now", color: "#5822b5" },
  { name: "Hayu", show: "Real Housewives", status: "Available now", color: "#d63384" },
];

const ENTERTAINMENT_CARDS = [
  { title: "Saturday Night Live UK", subtitle: "Watch now on Sky One", badge: "sky original", imgBg: "linear-gradient(135deg, #f5a623 0%, #d45200 50%, #8b1a00 100%)" },
  { title: "The Dyers' Caravan Park", subtitle: "Watch now on Sky One", badge: "sky", imgBg: "linear-gradient(135deg, #87ceeb 0%, #4682b4 50%, #1e3a5f 100%)" },
];

const SkyLogo = ({ size = 18 }) => (
  <div style={{
    background: "#e8001d", borderRadius: "4px",
    padding: `${Math.round(size * 0.22)}px ${Math.round(size * 0.55)}px`,
    fontWeight: "900", color: "#fff", fontSize: `${size}px`,
    letterSpacing: "-0.5px", fontStyle: "italic", lineHeight: 1.3,
    display: "inline-block", userSelect: "none",
  }}>sky</div>
);

const OutlineBtn = ({ children, style = {} }) => (
  <button style={{
    background: "transparent", color: "#0072c6", border: "1px solid #0072c6",
    borderRadius: "4px", padding: "8px 18px", fontSize: "13px",
    fontWeight: "600", cursor: "pointer", whiteSpace: "nowrap", ...style,
  }}>{children}</button>
);

const PrimaryBtn = ({ children, style = {} }) => (
  <button style={{
    background: "#0072c6", color: "#fff", border: "none",
    borderRadius: "4px", padding: "8px 18px", fontSize: "13px",
    fontWeight: "600", cursor: "pointer", whiteSpace: "nowrap", ...style,
  }}>{children}</button>
);

export default function SkyHomepage() {
  const [bannerVisible, setBannerVisible] = useState(true);
  const [legalOpen, setLegalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const m = isMobile;

  return (
    <div style={{ fontFamily: "Arial, sans-serif", color: "#333", background: "#fff", minHeight: "100vh" }}>

      {/* ── NAVBAR ── */}
      {/* <nav style={{
        background: "#fff", borderBottom: "1px solid #e0e0e0",
        display: "flex", alignItems: "center",
        padding: m ? "0 16px" : "0 24px",
        height: m ? "52px" : "48px",
        position: "sticky", top: 0, zIndex: 200,
      }}>
        {m ? (
          <>
            <button onClick={() => setMenuOpen(!menuOpen)} style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: "20px", color: "#333", padding: "4px", lineHeight: 1,
            }}>☰</button>
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <SkyLogo size={20} />
            </div>
            <button style={{
              background: "none", border: "1px solid #0072c6", color: "#0072c6",
              borderRadius: "4px", padding: "5px 12px", cursor: "pointer",
              fontSize: "13px", fontWeight: "600",
            }}>Sign in</button>
          </>
        ) : (
          <>
            <SkyLogo size={18} />
            <div style={{ display: "flex", gap: "4px", flex: 1, marginLeft: "16px" }}>
              {NAV_ITEMS.map((item) => (
                <button key={item.label} style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: "13px", fontWeight: "500", color: "#333",
                  padding: "4px 10px", borderRadius: "4px",
                  display: "flex", alignItems: "center", gap: "4px",
                }}>
                  {item.label}
                  {item.hasDropdown && <span style={{ fontSize: "9px", color: "#666" }}>▾</span>}
                </button>
              ))}
            </div>
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}>🔍</button>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}>🔔</button>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px", color: "#333", display: "flex", alignItems: "center", gap: "4px" }}>
                Help <span style={{ fontSize: "9px" }}>▾</span>
              </button>
              <button style={{
                background: "none", border: "1px solid #0072c6", color: "#0072c6",
                borderRadius: "4px", padding: "5px 14px", cursor: "pointer",
                fontSize: "13px", fontWeight: "600",
              }}>Sign in</button>
            </div>
          </>
        )}
      </nav> */}

      {/* Mobile menu */}
      {m && menuOpen && (
        <div style={{
          position: "fixed", top: "52px", left: 0, right: 0, bottom: 0,
          background: "#fff", zIndex: 190, overflowY: "auto",
          borderTop: "1px solid #e0e0e0",
        }}>
          {NAV_ITEMS.map((item) => (
            <div key={item.label} style={{
              padding: "15px 20px", borderBottom: "1px solid #f0f0f0",
              fontSize: "15px", fontWeight: "500",
              display: "flex", justifyContent: "space-between", cursor: "pointer",
            }}>
              {item.label}
              {item.hasDropdown && <span style={{ color: "#666" }}>›</span>}
            </div>
          ))}
        </div>
      )}

      {/* ── PROMO BANNER ── */}
      {bannerVisible && (
        <div style={{
          background: "linear-gradient(90deg, #ff6b00, #e8001d, #9b00d6)",
          color: "#fff", textAlign: "center",
          padding: m ? "10px 36px" : "8px 40px",
          fontSize: m ? "12px" : "13px", fontWeight: "500",
          position: "relative", lineHeight: 1.5,
        }}>
          Our lowest price is back. Sky TV &amp; Full Fibre |{" "}
          <span style={{ textDecoration: "underline", cursor: "pointer" }}>See all deals</span> ›
          <button onClick={() => setBannerVisible(false)} style={{
            position: "absolute", right: "12px", top: "50%",
            transform: "translateY(-50%)", background: "none", border: "none",
            color: "#fff", cursor: "pointer", fontSize: "16px",
          }}>✕</button>
        </div>
      )}

      {/* ── HERO ── */}
      <section className="relative w-full h-screen flex items-start md:items-center justify-center md:justify-start text-center md:text-left">
  
  {/* Background Image */}
  <div className="absolute inset-0">
    {/* Desktop Image */}
    <img
      src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt5320eee0773067c6/69c25c7802cb9804111d5b52/2026_Q1_March_WIH1_UK_PHP_Hero_Desktop_v1.png?format=webp&imageManager=true&impolicy=resize&width=1200"
      alt="Hero Background"
      className="hidden md:block w-full h-full object-cover"
    />

    {/* Mobile Image */}
    <img
      src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/bltd328fff76585f65b/69c25c789125f62bcc9f7724/2026_Q1_March_WIH1_UK_PHP_Hero_Mobile_v1.png?format=webp&imageManager=true&impolicy=resize&width=1600"
      alt="Hero Mobile Background"
      className="block md:hidden w-full h-full object-cover"
    />

    {/* Optional Overlay */}
    <div className="absolute inset-0 "></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 pt-20 md:pt-0 md:pl-16 max-w-2xl">
    
    <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight">
      Discover Something Amazing
    </h1>

    <p className="mt-4 text-gray-200 text-sm md:text-lg">
      Explore our latest collection and find the perfect product that fits your needs.
    </p>

    {/* Buttons */}
    <div className="mt-6 flex flex-col sm:flex-row items-center md:items-start justify-center md:justify-start gap-4">
      
      {/* Buy Now */}
      <button className="px-6 py-3 bg-green-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition duration-300">
        Buy Now
      </button>

      {/* Learn More */}
      <button className="px-6 py-3 bg-white hover:bg-gray-100 text-black font-semibold rounded-xl transition duration-300">
        Learn More
      </button>

    </div>
  </div>
</section>
      {/* ── MAIN CONTENT ── */}
      <main style={{ maxWidth: m ? "100%" : "1100px", margin: "0 auto", padding: m ? "20px 16px" : "32px 24px" }}>

        {/* SKY TV & FULL FIBRE CARD */}
       <div
  style={{
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    padding: m ? "20px 16px" : "32px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: m ? "column" : "row",
    gap: m ? "20px" : "40px",
    alignItems: m ? "stretch" : "center",
  }}
>
  {/* LEFT CONTENT */}
  <div style={{ flex: m ? "none" : "0 0 340px", width: m ? "100%" : "auto" }}>
    <p style={{ fontSize: "11px", color: "#666", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
      Our lowest price is back
    </p>

    <h2 style={{ fontSize: m ? "22px" : "28px", fontWeight: "800", marginBottom: "12px", lineHeight: "1.2" }}>
      Sky TV &amp; Full Fibre
    </h2>

    <p style={{ fontSize: "13px", color: "#555", lineHeight: "1.7", marginBottom: "20px" }}>
      130+ channels plus Disney+, Netflix &amp; discovery+ in one place, powered by the UK's fastest broadband for seamless streaming.
    </p>

    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      <PrimaryBtn>Buy now</PrimaryBtn>
      <OutlineBtn>See all deals</OutlineBtn>
    </div>
  </div>

  {/* RIGHT CONTENT */}
  <div
    style={{
      flex: 1,
      display: "flex",
      gap: "10px",
      flexDirection: m ? "row" : "row",
      height: "auto", // ✅ FIX: removed minHeight
    }}
  >
    {/* Sky tile */}
    <div
      style={{
        flex: 1,
        borderRadius: "8px",
        overflow: "hidden",
        background: "#1a1a2e",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div style={{ background: "linear-gradient(135deg, #0072c6, #00a3e0)", padding: "10px", textAlign: "center" }}>
        <span style={{ color: "#fff", fontWeight: "900", fontSize: "14px", fontStyle: "italic" }}>sky</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "8px" }}>
        {["SNL UK", "Peaky Blinders"].map((show, i) => (
          <div
            key={i}
            style={{
              background: i === 0 ? "#0072c6" : "#e50914",
              borderRadius: "4px",
              padding: "10px", // ✅ FIX: replaced flex height with padding
              display: "flex",
              alignItems: "flex-end",
              fontSize: "10px",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            {show}
          </div>
        ))}
      </div>

      <div
        style={{
          position: "absolute",
          right: "6px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "#fff",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "16px",
          color: "#333",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        }}
      >
        +
      </div>
    </div>

    {/* Fibre tile */}
    <div
      style={{
        flex: 1,
        borderRadius: "8px",
        overflow: "hidden",
        background: "linear-gradient(135deg, #ff6b35 0%, #e8001d 40%, #9b00d6 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "14px",
      }}
    >
      <h3 style={{ color: "#fff", fontSize: m ? "18px" : "24px", fontWeight: "900", lineHeight: "1.1" }}>
        Full<br />Fibre
      </h3>

      <div
        style={{
          background: "rgba(255,255,255,0.15)",
          borderRadius: "8px",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "22px",
        }}
      >
        📡
      </div>

      <p style={{ color: "rgba(255,255,255,0.9)", fontSize: "10px", fontWeight: "600", textAlign: "center" }}>
        The UK's fastest<br />broadband speeds
      </p>
    </div>
  </div>
</div>
<section className="px-4 md:px-10 py-5">
  
  <div className="relative rounded-2xl overflow-hidden border border-gray-200 shadow-lg min-h-[500px] md:min-h-[650px]">
    
    {/* Background Images */}
    <div className="absolute inset-0">
      {/* Desktop */}
      <img
        src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt452e7b350acb5e83/69cea1aa05b5be7113012678/2026_Q2_April_Php_Spotlight_PrePost_Desktop.png"
        alt="Background"
        className="hidden md:block w-full h-full object-contain"
      />

      {/* Mobile */}
      <img
        src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt982952f6bce3fccd/69cea1aa22934a513544a92c/2026_Q2_April_Php_Spotlight_PrePost_Mobile.png"
        alt="Background Mobile"
        className="block md:hidden w-full h-full object-contain"
      />
    </div>

    {/* Content */}
    <div className="relative z-10 flex items-start md:items-center h-full w-full px-6 md:px-16 py-10 md:py-16">
      
      {/* LEFT CONTENT */}
      <div className="max-w-xl text-black md:ml-0 mt-0 md:mt-20">
        
        <h2 className="text-2xl md:text-3xl text-gray-800 mr-0 md:mr-36 font-bold leading-tight">
          Upgrade Your Experience Today
        </h2>

        <p className="mt-4 text-gray-600 text-sm md:text-lg mr-0 md:mr-32">
          Get access to premium features, faster performance, and a seamless experience across all your devices.
        </p>

        {/* Buttons */}
        <div className="mt-6 flex flex-col sm:flex-row gap-4">
          
          <button className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl transition">
            Buy Now
          </button>

          <button className="px-6 py-3 bg-white hover:bg-gray-100 text-black font-semibold rounded-xl transition border">
            Learn More
          </button>

        </div>
      </div>

    </div>
  </div>
</section>







        {/* PRODUCT CARDS */}
        <div style={{
          display: "grid",
          gridTemplateColumns: m ? "1fr" : "1fr 1fr",
          gap: "20px",
        }}>

          {/* Sky Sports Masters */}
          <div style={{ border: "1px solid #e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
            <div style={{ padding: m ? "20px 16px 14px" : "28px 28px 16px" }}>
              <p style={{ fontSize: "11px", color: "#666", marginBottom: "6px" }}>Sky Sports</p>
              <h2 style={{ fontSize: m ? "20px" : "24px", fontWeight: "800", marginBottom: "10px" }}>It's Masters time.</h2>
              <p style={{ fontSize: "13px", color: "#555", lineHeight: "1.6", marginBottom: "18px" }}>
                Watch every unmissable moment of The Masters live, when it tees off on April 9, exclusively on Sky Sports. Get Sky TV, Netflix and Sky Sports.
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                <OutlineBtn>See all deals</OutlineBtn>
                <PrimaryBtn>Buy now</PrimaryBtn>
              </div>
            </div>
            <div style={{
              background: "linear-gradient(135deg, #1a4a1a, #2d7a2d)",
              height: m ? "160px" : "200px",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: m ? "30px" : "36px", fontWeight: "900", fontStyle: "italic", color: "#ffd700", textShadow: "2px 2px 8px rgba(0,0,0,0.5)", lineHeight: "1" }}>
                  It's<br />Masters<br />time
                </div>
                <div style={{ marginTop: "8px", background: "#0072c6", display: "inline-block", padding: "2px 8px", borderRadius: "3px", fontSize: "11px", fontWeight: "700", color: "#fff" }}>
                  sky sports
                </div>
              </div>
            </div>
          </div>

          {/* MacBook Neo */}
          <div style={{ border: "1px solid #e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
            <div style={{ padding: m ? "20px 16px 14px" : "28px 28px 16px" }}>
              <p style={{ fontSize: "11px", color: "#666", marginBottom: "6px" }}>Sky Mobile</p>
              <h2 style={{ fontSize: m ? "20px" : "22px", fontWeight: "800", marginBottom: "10px" }}>MacBook Neo 13-Inch (2026)</h2>
              <p style={{ fontSize: "13px", color: "#555", lineHeight: "1.6", marginBottom: "18px" }}>
                From £12.50 a month. Pair with 5GB for just £6 extra a month for the first 3 months.
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                <OutlineBtn>See more</OutlineBtn>
                <PrimaryBtn>Buy now</PrimaryBtn>
              </div>
            </div>
            <div style={{
              background: "#f5f5f5", height: m ? "160px" : "200px",
              display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "8px",
            }}>
              <div style={{ fontSize: "18px", fontWeight: "900", color: "#111" }}>Hello, Neo.</div>
              <div style={{
                width: "110px", height: "68px",
                background: "linear-gradient(135deg, #7cfc00, #ffd700, #00bfff)",
                borderRadius: "6px", border: "3px solid #222",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px",
              }}>💻</div>
              <div style={{ fontSize: "10px", color: "#888" }}>MacBook Neo</div>
            </div>
          </div>

          {/* Full Fibre Broadband */}
          <div style={{ border: "1px solid #e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
            <div style={{ padding: m ? "20px 16px 14px" : "28px 28px 16px" }}>
              <p style={{ fontSize: "11px", color: "#666", marginBottom: "6px" }}>Sky Broadband</p>
              <h2 style={{ fontSize: m ? "20px" : "24px", fontWeight: "800", marginBottom: "10px" }}>Full Fibre broadband</h2>
              <p style={{ fontSize: "13px", color: "#555", lineHeight: "1.6", marginBottom: "18px" }}>
                On the UK's most reliable broadband technology. Switch and claim up to £200 towards leaving fees.
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                <OutlineBtn>Learn more</OutlineBtn>
                <PrimaryBtn>Buy now</PrimaryBtn>
              </div>
            </div>
            <div style={{
              background: "linear-gradient(135deg, #ff6b00, #e8001d)",
              padding: "22px 20px", display: "flex", alignItems: "center", gap: "16px",
            }}>
              <div style={{
                width: "52px", height: "68px", background: "#111",
                borderRadius: "6px", flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px",
              }}>📦</div>
              <div>
                <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", marginBottom: "2px" }}>Switch and get up to</p>
                <div style={{ color: "#fff", fontSize: "34px", fontWeight: "900", lineHeight: "1" }}>£200</div>
                <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px" }}>towards leaving fees</p>
              </div>
            </div>
          </div>

          {/* Sky Glass Air */}
          <div style={{ border: "1px solid #e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
            <div style={{ padding: m ? "20px 16px 14px" : "28px 28px 16px" }}>
              <p style={{ fontSize: "11px", color: "#666", marginBottom: "6px" }}>The brand new</p>
              <h2 style={{ fontSize: m ? "20px" : "24px", fontWeight: "800", marginBottom: "10px" }}>Sky Glass Air TV</h2>
              <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.6", marginBottom: "18px" }}>
                The smartest TV range just got better.
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                <OutlineBtn>Learn more</OutlineBtn>
                <PrimaryBtn>Buy now</PrimaryBtn>
              </div>
            </div>
            <div style={{
              background: "linear-gradient(135deg, #7b2ff7, #00b4d8, #ff6b35)",
              height: m ? "160px" : "180px",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <div style={{
                background: "rgba(0,0,0,0.3)", backdropFilter: "blur(8px)",
                borderRadius: "8px", padding: "12px 24px", textAlign: "center",
              }}>
                <div style={{ color: "#fff", fontSize: "12px", fontStyle: "italic", letterSpacing: "1px" }}>sky</div>
                <div style={{ color: "#fff", fontSize: "22px", fontWeight: "900", letterSpacing: "1px" }}>glass</div>
                <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px", letterSpacing: "2px" }}>air</div>
              </div>
            </div>
          </div>
        </div>

        {/* ── SKY ENTERTAINMENT ── */}
        <section style={{ marginTop: m ? "32px" : "48px" }}>
          <h2 style={{ fontSize: m ? "22px" : "28px", fontWeight: "800", textAlign: "center", marginBottom: "20px" }}>
            Sky Entertainment
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "20px" }}>
            {ENTERTAINMENT_CARDS.map((card, i) => (
              <div key={i} style={{ borderRadius: "8px", overflow: "hidden", cursor: "pointer" }}>
                <div style={{
                  height: m ? "140px" : "220px",
                  background: card.imgBg, position: "relative",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <div style={{
                    position: "absolute", top: "10px", left: "10px",
                    background: "rgba(0,114,198,0.9)", borderRadius: "4px",
                    padding: "2px 6px", fontSize: "10px", color: "#fff",
                    fontStyle: "italic", fontWeight: "700",
                  }}>{card.badge}</div>
                  <span style={{ fontSize: "32px", opacity: 0.35 }}>🎬</span>
                </div>
                <div style={{ padding: "8px 2px" }}>
                  <p style={{ fontWeight: "700", fontSize: m ? "12px" : "14px", marginBottom: "2px" }}>{card.title}</p>
                  <p style={{ fontSize: "11px", color: "#666" }}>{card.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "32px" }}>
            {["‹", "›"].map((ch, i) => (
              <button key={i} style={{
                width: "32px", height: "32px",
                border: "1px solid #ccc", borderRadius: "4px",
                background: i === 0 ? "#f5f5f5" : "#fff",
                cursor: "pointer", fontSize: "14px",
                color: i === 0 ? "#999" : "#333",
              }}>{ch}</button>
            ))}
          </div>
        </section>

        {/* ── LEGAL ACCORDION ── */}
        <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", marginBottom: "32px", overflow: "hidden" }}>
          <button onClick={() => setLegalOpen(!legalOpen)} style={{
            width: "100%", padding: "16px 20px",
            background: "#f9f9f9", border: "none", cursor: "pointer",
            display: "flex", justifyContent: "space-between", alignItems: "center",
            fontSize: "14px", color: "#333", fontWeight: "500",
          }}>
            Here's the legal bit
            <span style={{
              fontSize: "18px", color: "#666", display: "inline-block",
              transform: legalOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s",
            }}>⌄</span>
          </button>
          {legalOpen && (
            <div style={{ padding: "16px 20px", fontSize: "12px", color: "#666", lineHeight: "1.7" }}>
              Offers subject to status and availability. Sky TV and Sky Mobile offer subject to a 24-month minimum term. Prices may vary. See sky.com for full details and terms and conditions.
            </div>
          )}
        </div>
      </main>

      {/* ── FOOTER ── */}
      <footer style={{ background: "#fff", borderTop: "1px solid #e0e0e0", padding: m ? "20px 16px" : "24px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          {m ? (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px", marginBottom: "16px" }}>
                {["Privacy options", "Terms & conditions", "Privacy & cookies notice", "Accessibility", "Site map", "Contact us", "Compliance", "Sky Group"].map((link) => (
                  <a key={link} href="#" style={{ fontSize: "12px", color: "#555", textDecoration: "none" }}>{link}</a>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #eee" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <SkyLogo size={14} />
                  <span style={{ fontSize: "11px", color: "#888" }}>© 2026 Sky UK</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontSize: "11px", color: "#555" }}>Country:</span>
                  <span style={{ fontSize: "15px" }}>🇬🇧</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "24px", marginBottom: "16px" }}>
                {["Privacy options", "Terms & conditions", "Privacy & cookies notice", "Accessibility", "Site map", "Contact us"].map((link) => (
                  <a key={link} href="#" style={{ fontSize: "12px", color: "#555", textDecoration: "none" }}>{link}</a>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "center", gap: "24px", marginBottom: "16px" }}>
                {["Compliance", "Sky Group", "Store locator"].map((link) => (
                  <a key={link} href="#" style={{ fontSize: "12px", color: "#555", textDecoration: "none" }}>{link}</a>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <SkyLogo size={14} />
                  <span style={{ fontSize: "12px", color: "#888" }}>© 2026 Sky UK</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "12px", color: "#555" }}>Country:</span>
                  <span style={{ fontSize: "16px" }}>🇬🇧</span>
                </div>
              </div>
            </>
          )}
        </div>
      </footer>
    </div>
  );
}
